import React from 'react'

const Notification = () => {
  return (
    <>
      <section>
        <h1>Notification</h1>
      </section> 
    </>
  )
}

export default Notification
